// Existing MML archive: source URL, exact original records and provenance retained in handoff. Only crash terminology normalized.
export const archivedResults = [
  {
    "id": "archive-result-1",
    "amount": "$27,512,000",
    "type": "Verdict",
    "description": "Winning for our injured client resulted in a record Jury Verdict, Michigan’s largest ever for motorcycle crash injury lawsuit."
  },
  {
    "id": "archive-result-2",
    "amount": "$2,000,000",
    "type": "Verdict",
    "description": "Death, auto negligence and claim against road construction company for improper signage and negligence. St. Clair County."
  },
  {
    "id": "archive-result-3",
    "amount": "$2,000,000",
    "type": "Settlement",
    "description": "Motorcycle hits road construction defect."
  },
  {
    "id": "archive-result-4",
    "amount": "$1,500,000",
    "type": "Settlement",
    "description": "Motorcyclist suffers broken leg from auto negligence."
  },
  {
    "id": "archive-result-5",
    "amount": "$1,400,000",
    "type": "Settlement",
    "description": "Motorcycle hit by elderly driver. Severe leg injury with multiple surgeries."
  },
  {
    "id": "archive-result-6",
    "amount": "$1,250,000",
    "type": "Settlement",
    "description": "Motorcycle crash resulting in death, no helmet, disputed liability. Lapeer County."
  },
  {
    "id": "archive-result-7",
    "amount": "$1,000,000",
    "type": "Arbitration",
    "description": "Motorcycle crash, road construction negligence."
  },
  {
    "id": "archive-result-8",
    "amount": "$1,000,000",
    "type": "Settlement",
    "description": "Semi-truck made improper right turn across motorcyclist’s path causing broken bones and significant work loss."
  },
  {
    "id": "archive-result-9",
    "amount": "$1,000,000",
    "type": "Settlement",
    "description": "Motorcycle hit by semi-truck, multiple broken bones and wage loss. Wayne County."
  },
  {
    "id": "archive-result-10",
    "amount": "$1,200,000",
    "type": "Arbitration",
    "description": "Severe injury to internal organs, abdomen, and arm, Wayne County Michigan"
  },
  {
    "id": "archive-result-11",
    "amount": "$975,000",
    "type": "Settlement",
    "description": "Motorcycle crash where at-fault driver turned left directly in front of the motorcyclist at an intersection. Multiple fractures and leg surgery. Port Huron Michigan"
  },
  {
    "id": "archive-result-12",
    "amount": "$125,000",
    "type": "Settlement",
    "description": "Motorcycle crash, fractured leg with surgery, Lapeer Michigan"
  },
  {
    "id": "archive-result-13",
    "amount": "$677,000",
    "type": "Verdict",
    "description": "Motorcycle crash. Fractured leg, arm, and back injury. Washtenaw County, Michigan."
  },
  {
    "id": "archive-result-14",
    "amount": "$550,000",
    "type": "Verdict",
    "description": "10 mph minimal-vehicle-damage, client was diagnosed with neck strain but ended up having surgery two years later. Highest offer was $5000. Attorney fees court costs in case evaluation sanctions applied. Oakland County, Michigan."
  },
  {
    "id": "archive-result-15",
    "amount": "$450,000",
    "type": "Settlement",
    "description": "Facilitation included this motorcycle crash where an elderly woman made a U-turn in front of our client’s motorcycle. He broke his left foot and ankle in multiple places and required surgeries."
  },
  {
    "id": "archive-result-16",
    "amount": "$350,000",
    "type": "Verdict",
    "description": "Van rolled over, leg fracture. Clair County, Michigan."
  },
  {
    "id": "archive-result-17",
    "amount": "$225,000",
    "type": "Settlement",
    "description": "Motorcycle crash. Fractured wrist."
  },
  {
    "id": "archive-result-18",
    "amount": "$90,000",
    "type": "Verdict",
    "description": "Motorcyclist was in stop and go traffic when a car merged through the traffic in the attempt to go into a parking lot. She struck the motorcyclist at a relatively low speed. Highest offer was $30,000. Court costs, attorney fees and mediation sanctions applied. Oakland County, Michigan."
  },
  {
    "id": "archive-result-19",
    "amount": "$100,000",
    "type": "Settlement",
    "description": "Motorcycle, driver came across two lanes of traffic. Fractured tibia/fibula"
  },
  {
    "id": "archive-result-20",
    "amount": "$80,000",
    "type": "Settlement",
    "description": "Auto crash, diagnosed with fibromyalgia and reflex sympathetic dystrophy."
  },
  {
    "id": "archive-result-21",
    "amount": "$65,000",
    "type": "Settlement",
    "description": "Motorcycle crash. Settled $15,000 over policy limits while picking a jury. Bulging discs in neck."
  },
  {
    "id": "archive-result-22",
    "amount": "$25,800",
    "type": "Settlement",
    "description": "Motor Vehicle crash (MVA), Wyane County, child injury, Canton Michigan."
  },
  {
    "id": "archive-result-23",
    "amount": "$187,000",
    "type": "Settlement",
    "description": "Motorcyclist with fractured wrist requiring two surgeries, Woodhaven Michigan"
  },
  {
    "id": "archive-result-24",
    "amount": "$475,000",
    "type": "Mediation",
    "description": "Motorcycle injury crash. Negligent driver crossed the highway directly in front of the motorcyclist causing a T-bone impact. Aggravation of major back injury, wrist and shoulder new injury. Surgery. Howell, Michigan"
  },
  {
    "id": "archive-result-25",
    "amount": "$187,500",
    "type": "Settlement",
    "description": "Passenger motorcycle, broken vertebrae and collapsed lung, Western Michigan"
  },
  {
    "id": "archive-result-26",
    "amount": "$100,000",
    "type": "Settlement",
    "description": "Motor vehicle crash, nerve damage at-fault driver fled the scene, Detroit Michigan"
  },
  {
    "id": "archive-result-27",
    "amount": "$62,500",
    "type": "Mediation",
    "description": "Negligence case with torn meniscus of the knee, Commerce Township Michigan"
  },
  {
    "id": "archive-result-28",
    "amount": "$45,000",
    "type": "Settlement",
    "description": "Seventy years old bicyclist hit by car, road rash and laceration with stitches. Bloomfield Hills, Michigan"
  },
  {
    "id": "archive-result-29",
    "amount": "$100,000",
    "type": "Settlement",
    "description": "Full policy limits of underlying negligent driver as well as under-insured policy limits paid to broken down motorist whose car was hit by a negligent driver as a tow truck was assisting him. Fractured bones in his leg among other injuries."
  },
  {
    "id": "archive-result-30",
    "amount": "$695,000",
    "type": "Settlement",
    "description": "Drunk driver hits motorcyclist on Highway and flees. Severe motorcycle injury crash. We sued the bar under dramshop law and liquor liability laws for over-serving the at-fault driver who caused significant injury. In most cases no more than five depositions are taken on the “typical” motor vehicle crash. In this case almost 30 depositions were conducted by plaintiff’s counsel to prove this difficult case."
  },
  {
    "id": "archive-result-31",
    "amount": "$92,500",
    "type": "Settlement",
    "description": "Motorcyclist rear-ended by car. Injuries included two severe finger fractures, left wrist fracture. Westland Michigan Wayne County."
  },
  {
    "id": "archive-result-32",
    "amount": "$90,000",
    "type": "Settlement",
    "description": "Bilateral shoulder injury and aggravation of degenerative joint disease with shoulder procedure"
  },
  {
    "id": "archive-result-33",
    "amount": "$35,000",
    "type": "Settlement",
    "description": "Case evaluation mutual acceptance settlement for auto crash client with neck and back complaints."
  },
  {
    "id": "archive-result-34",
    "amount": "$100,000",
    "type": "Settlement",
    "description": "Motorcycle crash claim settled without filing lawsuit, Injuries to motorcyclist were laceration to arm and fractured tibia/fibula."
  },
  {
    "id": "archive-result-35",
    "amount": "$23,000",
    "type": "Settlement",
    "description": "Low back and right hip pain"
  },
  {
    "id": "archive-result-36",
    "amount": "$35,000",
    "type": "Settlement",
    "description": "Motor vehicle crash aggravation back injury, Mussey, MI"
  },
  {
    "id": "archive-result-37",
    "amount": "$39,000",
    "type": "Settlement",
    "description": "Medical bills paid for motorcyclist"
  },
  {
    "id": "archive-result-38",
    "amount": "$75,000",
    "type": "Facilitation",
    "description": "Right thumb injury causing arthritis, with injections to auto crash client"
  },
  {
    "id": "archive-result-39",
    "amount": "$25,000",
    "type": "Settlement",
    "description": "Motorcyclist with leg injury, Olivet, Michigan"
  },
  {
    "id": "archive-result-40",
    "amount": "$50,000",
    "type": "Settlement",
    "description": "Attendant care services paid a family member of injured motorcyclist. Western Michigan."
  },
  {
    "id": "archive-result-41",
    "amount": "$35,000",
    "type": "Settlement",
    "description": "ATV injury involving a minor, back injury. Wolverine Lake Michigan"
  },
  {
    "id": "archive-result-42",
    "amount": "$120,000",
    "type": "Settlement",
    "description": "Motorcycle crash with fractured clavicle and surgery – open reduction internal fixation surgery. Back spasms. Clawson Michigan"
  },
  {
    "id": "archive-result-43",
    "amount": "$60,000",
    "type": "Settlement",
    "description": "Motorcycle crash where the motorcyclist was rear-ended by the at fault driver. Aggravation of pre-existing shoulder injury previously had surgery. Burton Michigan"
  },
  {
    "id": "archive-result-44",
    "amount": "$160,000",
    "type": "Settlement",
    "description": "Motorcycle wreck case motorcyclist suffered severe injuries including a back injury were L4 -S1 fusion surgery was performed. Detroit Michigan Wayne County"
  },
  {
    "id": "archive-result-45",
    "amount": "$20,000",
    "type": "Settlement",
    "description": "Motor vehicle crash involving unspecified back injuries to an elderly man, Detroit Michigan Wayne County"
  },
  {
    "id": "archive-result-46",
    "amount": "$25,000",
    "type": "Settlement",
    "description": "Motorcycle case where the motorcyclist suffered a cracked rib, sprained wrist and back complaints. White cloud Michigan."
  },
  {
    "id": "archive-result-47",
    "amount": "$65,000",
    "type": "Settlement",
    "description": "Motorcyclist hit dog running at large. Motorcycle crash. We have handled many of these types of cases. Many lawyers do not know where to go and what damages are compensable. Road rash, fractured wrist, medical bills and wage loss paid. Sheridan, MI near Grand Rapids Michigan."
  },
  {
    "id": "archive-result-48",
    "amount": "$40,000",
    "type": "Settlement",
    "description": "Motorcycle crash involving a farm tractor taking up most of the road. Broken fingers with a procedure. Belding, Michigan. Grand Rapids area."
  },
  {
    "id": "archive-result-49",
    "amount": "$50,000",
    "type": "Settlement",
    "description": "Motorcycle wreck case where elderly man turned into his driveway directly in the path of the motorcyclist. Tendon injury to his right hand with cortisone injections. Oakland Michigan"
  },
  {
    "id": "archive-result-50",
    "amount": "$25,000",
    "type": "Settlement",
    "description": "Motor vehicle crash involving injuries to a sore back neck and legs. Patient ended up having a slap tear shoulder repair. St. Clair Shores Michigan"
  },
  {
    "id": "archive-result-51",
    "amount": "$15,000",
    "type": "Settlement",
    "description": "Motor vehicle crash involving soft tissue injuries out-of-state resident in Michigan crash"
  },
  {
    "id": "archive-result-52",
    "amount": "$60,000",
    "type": "Settlement",
    "description": "Motorcycle injury crash involving hit and run driver. Hairline fracture vertebrae, severe bruising. Treated with an orthopedic specialist. UIM claim."
  },
  {
    "id": "archive-result-53",
    "amount": "$33,500",
    "type": "Settlement",
    "description": "Motor Vehicle crash (MVA) with whiplash or soft tissue injuries, sprained ankle. Garden City Michigan Wayne County."
  },
  {
    "id": "archive-result-54",
    "amount": "$75,000",
    "type": "Settlement",
    "description": "Motor vehicle collision involving a minor that developed a serious impairment of important body function related to this crash."
  },
  {
    "id": "archive-result-55",
    "amount": "$16,000",
    "type": "Settlement",
    "description": "Auto crash claim alleging whiplash type injuries to soft tissues of the client’s neck and/or back. Macomb County Michigan"
  },
  {
    "id": "archive-result-56",
    "amount": "$75,000",
    "type": "Settlement",
    "description": "Motorcyclist who was hit by a Jeep making a left turn into a private driveway. He was wearing a helmet but hit his head. Loss of consciousness. Mild closed head injury. Wayne County Michigan"
  },
  {
    "id": "archive-result-57",
    "amount": "$21,500",
    "type": "Settlement",
    "description": "Severe sprain to ankle, leg numbness with back and neck complaints. Wayne County Michigan"
  },
  {
    "id": "archive-result-58",
    "amount": "$210,000",
    "type": "Settlement",
    "description": "Motor vehicle crash where client was rear-ended while sitting at a light. Originally diagnosed with neck strain but ended up having surgery. Case was complicated because he had degenerative changes in pre-existing conditions."
  },
  {
    "id": "archive-result-59",
    "amount": "$130,000",
    "type": "Settlement",
    "description": "No-fault benefits to motorcyclist. Auto insurance company disputed they owed the motorcyclist the payment of medical bills and attendant care."
  },
  {
    "id": "archive-result-60",
    "amount": "$85,000",
    "type": "Settlement",
    "description": "Motorcyclist crashed because other driver moved into his lane of traffic. Fractured bone. Ypsilanti Michigan Washtenaw County."
  },
  {
    "id": "archive-result-61",
    "amount": "$35,500",
    "type": "Settlement",
    "description": "Car crash case sprain of AC joint with possible tear, Warren Michigan"
  },
  {
    "id": "archive-result-62",
    "amount": "$85,000",
    "type": "Settlement",
    "description": "Car crash involving injury to shoulder, side, hip, neck and back."
  },
  {
    "id": "archive-result-63",
    "amount": "$57,500",
    "type": "Settlement",
    "description": "Motorcycle crash with left rotator cuff injury, fracture of the humeral head. Kimball Township Michigan"
  },
  {
    "id": "archive-result-64",
    "amount": "$85,000",
    "type": "Settlement",
    "description": "Motorcycle crash involving highway defect. Loss of consciousness, left elbow fracture, right shoulder fracture and road rash. Highway defect cases are difficult because the government entity in charge of the roadway must’ve known about the defect and it must have been there for over 30 days. Wayne County Michigan"
  },
  {
    "id": "archive-result-65",
    "amount": "$7,500",
    "type": "Settlement",
    "description": "Motor vehicle crash involving complaints to soft tissues of back and shoulder. Dearborn Michigan"
  },
  {
    "id": "archive-result-66",
    "amount": "$50,000",
    "type": "Settlement",
    "description": "Auto crash case with cervical strain and partial tendon tear in shoulder. Oak Park Michigan Wayne County."
  },
  {
    "id": "archive-result-67",
    "amount": "$5,000",
    "type": "Settlement",
    "description": "Motorcycle injury crash with small laceration."
  },
  {
    "id": "archive-result-68",
    "amount": "$35,000",
    "type": "Settlement",
    "description": "Motorcycle Vehicle crash (MVA) where our client had significant prior injuries and pre-existing conditions that complicated the case. We alleged an aggravation of pre-existing condition involving herniated discs. St. Clair Shores Michigan / Port Huron Michigan."
  },
  {
    "id": "archive-result-69",
    "amount": "$50,000",
    "type": "Settlement",
    "description": "Motorcycle crash where automobile crash parking lot directly into the path of the motorcyclist causing the crash. Injuries included fractured ribs and a broken foot."
  },
  {
    "id": "archive-result-70",
    "amount": "$30,000",
    "type": "Settlement",
    "description": "Motorcycle crash compensating passenger of motorcycle who complained of arm and leg pain. She also had some road rash."
  },
  {
    "id": "archive-result-71",
    "amount": "$40,000",
    "type": "Settlement",
    "description": "Motorcycle injury crash claim where car pulled out in front of motorcyclist. Pain or cortisone injections into his lower back diagnosed bulging disc. Bay City Michigan"
  },
  {
    "id": "archive-result-72",
    "amount": "$15,000",
    "type": "Settlement",
    "description": "MVA laceration to head with stitches. Midland Michigan."
  },
  {
    "id": "archive-result-73",
    "amount": "$20,000",
    "type": "Settlement",
    "description": "Motorcycle case receiving full policy for broken ribs and road rash. St. Louis Michigan"
  },
  {
    "id": "archive-result-74",
    "amount": "$85,000",
    "type": "Settlement",
    "description": "Motorcycle wreck involving injury to shoulder requiring shoulder scope surgery and dislocated collarbone. Nashville Michigan"
  },
  {
    "id": "archive-result-75",
    "amount": "$15,000",
    "type": "Settlement",
    "description": "Elderly woman involved in motor vehicle collision complaining of soft tissue injuries of the neck, hematoma to the head with headaches. Harper Woods Michigan"
  },
  {
    "id": "archive-result-76",
    "amount": "$75,000",
    "type": "Settlement",
    "description": "Motorcycle injury crash where motorcyclist was forced to lay down the motorcycle severe road rash and abrasion to hand. Possible closed head injury. Grand Rapids Michigan"
  },
  {
    "id": "archive-result-77",
    "amount": "$20,000",
    "type": "Settlement",
    "description": "Motorcycle hit by car where at fault driver turned left directly in front of motorcyclist at an intersection. Injury to pelvis, Hudsonville Michigan"
  },
  {
    "id": "archive-result-78",
    "amount": "$55,000",
    "type": "Settlement",
    "description": "Motorcycle injury crash with knee injury involving torn meniscus. Laingsburg, Michigan."
  },
  {
    "id": "archive-result-79",
    "amount": "$150,000",
    "type": "Settlement",
    "description": "Negligence case involving personal injuries Alpena Michigan"
  },
  {
    "id": "archive-result-80",
    "amount": "$100,000",
    "type": "Settlement",
    "description": "Third-party auto crash case involving a pothole. The driver hit a pothole and lost control. Broken pelvis"
  },
  {
    "id": "archive-result-81",
    "amount": "$33,000",
    "type": "Settlement",
    "description": "Michigan auto crash with fractured collarbone. Lincoln Park Michigan"
  },
  {
    "id": "archive-result-82",
    "amount": "$75,000",
    "type": "Settlement",
    "description": "Motorcycle crash mild closed head injury, road rash. Grand Rapids Michigan"
  },
  {
    "id": "archive-result-83",
    "amount": "$85,000",
    "type": "Settlement",
    "description": "Motor vehicle collision involving a cab. Low back injury L5-S1"
  },
  {
    "id": "archive-result-84",
    "amount": "$100,000",
    "type": "Settlement",
    "description": "Automobile crash with torn rotator cuff shoulder. Monroe Michigan"
  },
  {
    "id": "archive-result-85",
    "amount": "$30,000",
    "type": "Settlement",
    "description": "Motor vehicle negligence case aggravation of prior knee replacement. Flint Michigan"
  },
  {
    "id": "archive-result-86",
    "amount": "$10,000",
    "type": "Settlement",
    "description": "Motorcycle hit by negligent driver attempting to make left turn. Broken rib(s). Ecorse Michigan"
  },
  {
    "id": "archive-result-87",
    "amount": "$75,000",
    "type": "Settlement",
    "description": "Auto related case involving negligence of driver who failed to pay attention to his or her surroundings. Neck and back complaints including severe headaches possible closed head injury. Melvindale, Michigan"
  },
  {
    "id": "archive-result-88",
    "amount": "$175,000",
    "type": "Settlement",
    "description": "Motor vehicle collision crash were client struck her head. Close head injury."
  }
];
